<template>
  <div class="dashboard-container">
    <!-- 背景层 -->
    <div class="background-layer"></div>

    <div class="main-content">
      <!-- 标题区 -->
      <!-- <div class="dashboard-header">
        <h1><i class="el-icon-data-analysis"></i> 数据监控看板</h1>
        <div class="header-decoration"></div>
      </div> -->

      <!-- 功能区 -->
      <el-card class="operation-card">
        <el-row :gutter="20" class="filter-row">
          <el-col :xs="24" :sm="24" :md="16" :lg="18" :xl="20" class="time-col">
            <el-row :gutter="15">
               <el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16">
                <el-date-picker
                  v-model="timeRange"
                  type="datetimerange"
                  range-separator="-"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  class="enhanced-time-picker"
                  :picker-options="pickerOptions"
                />
              </el-col>
              <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                <el-button
                  type="primary"
                  icon="el-icon-search"
                  @click="handleQuery"
                  class="query-button"
                  :loading="loading"
                >
                  立即查询
                </el-button>
              </el-col>
            
            </el-row>
          </el-col>
          
          <el-col :xs="24" :sm="24" :md="8" :lg="6" :xl="4" class="search-col">
            <el-input
              v-model="searchKey"
              placeholder="请输入关键词搜索"
              clearable
              class="search-input"
              @keyup.enter.native="handleQuery"
            >
              <i slot="prefix" class="el-icon-search"></i>
            </el-input>
          </el-col>
        </el-row>
      </el-card>

      

      <!-- 数据表格 -->
      <el-card class="data-card">
        <el-table
          :data="processedData"
          stripe
          style="width: 100%"
          v-loading="loading"
          class="enhanced-table"
        >
          <el-table-column
            prop="src"
            label="渠道"
            width="120"
            align="center"
          />

          <el-table-column
            prop="target"
            label="广告主"
            width="160"
            align="center"
          />

          <el-table-column
            prop="groupdesc"
            label="广告组"
            width="120"
            align="center"
          />

          <el-table-column
            prop="click"
            label="点击数"
            width="120"
            align="center"
          />

          <!-- 修改后的合成列 -->
          <el-table-column label="激活" align="center">
            <template #default="{row}">
              <span :class="{'data-highlight': row.active > 0}">
                {{ row.active }}/{{ row.callactive }}
              </span>
            </template>
          </el-table-column>

          <el-table-column label="激活率" align="center">
            <template #default="{row}">
              <span :class="'data-persent'">
                {{ row.click > 0 ? (row.active / row.click * 100).toFixed(2) : 0}}%
              </span>
            </template>
          </el-table-column>      

          <!-- 注册列 -->
          <el-table-column label="注册" align="center">
            <template #default="{row}">
              <span :class="{'data-highlight': row.register > 0}">
                {{ row.register }}/{{ row.callregister }}
              </span>
            </template>
          </el-table-column>

          <el-table-column label="注册率" align="center">
            <template #default="{row}">
              <span :class="'data-persent'">
                {{ row.click > 0 ? (row.register / row.click * 100).toFixed(2) : 0}}%
              </span>
            </template>
          </el-table-column>      

          <!-- 次留列 -->
          <el-table-column label="次留" align="center">
            <template #default="{row}">
              <span :class="{'data-highlight': row.retainDay > 0}">
                {{ row.retainDay }}/{{ row.callretainDay }}
              </span>
            </template>
          </el-table-column>

          <!-- 唤醒列 -->
          <el-table-column label="唤醒" align="center">
            <template #default="{row}">
              <span :class="{'data-highlight': row.wake > 0}">
                {{ row.wake }}/{{ row.callwake }}
              </span>
            </template>
          </el-table-column>

          <el-table-column label="唤醒率" align="center">
            <template #default="{row}">
              <span :class="'data-persent'">
                {{ row.click > 0 ? (row.wake / row.click * 100).toFixed(2) : 0}}%
              </span>
            </template>
          </el-table-column>      


          <!-- 付费列 -->
          <el-table-column label="付费" align="center">
            <template #default="{row}">
              <span :class="{'data-highlight': row.pay > 0}">
                {{ row.pay }}/{{ row.callpay }}
              </span>
            </template>
          </el-table-column>

          <el-table-column label="付费率" align="center">
            <template #default="{row}">
              <span :class="'data-persent'">
                {{ row.click > 0 ? (row.pay / row.click * 100).toFixed(2) : 0}}%
              </span>
            </template>
          </el-table-column>      

        </el-table>
      </el-card>
    </div>
  </div>
</template>

<script>


import {dayloglist} from '../api/index'
import dayjs from 'dayjs'




export default {
  name: 'Dashboard',
  data() {
    return {
      timeRange: [
        dayjs().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
        dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss')
      ],
      tableData: [],
      rawData: [],
      loading: false,
      searchKey: '', // 新增搜索关键词
      pickerOptions: {
        shortcuts:[{
          text: '今天',
          onClick(picker) {
            const start = dayjs().startOf('day').format('YYYY-MM-DD HH:mm:ss')
            const end = dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss')
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const start = dayjs().subtract(1, 'day').startOf('day').format('YYYY-MM-DD HH:mm:ss')
            const end = dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss')
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一周',
          onClick(picker) {
            const start = dayjs().subtract(7, 'day').startOf('day').format('YYYY-MM-DD HH:mm:ss')
            const end = dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss')
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一月',
          onClick(picker) {
            const start = dayjs().subtract(1, 'month').startOf('week').format('YYYY-MM-DD HH:mm:ss')
            const end = dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss')
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三月',
          onClick(picker) {
            const start = dayjs().subtract(3, 'month').startOf('month').format('YYYY-MM-DD HH:mm:ss')
            const end = dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss')
            picker.$emit('pick', [start, end])
          }
        }]
      }
    }
  },
  created(){
    this.timeRange = [
        dayjs().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
        dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss')
      ]
    this.handleQuery()
  },
  computed: {
    processedData() {
      // 模糊匹配过滤
      const filtered = this.rawData.filter(item => {
        const searchText = this.searchKey.toLowerCase()
        const src = item.src?.toString().toLowerCase() || ''
        const target = item.target?.toString().toLowerCase() || ''
        return src.includes(searchText) || target.includes(searchText)
      })

      // 分组排序逻辑（与原handleQuery中的相同）
      const grouped = filtered.reduce((groups, item) => {
        const key = item.target || '未知'
        if (!groups[key]) {
          groups[key] = { total: 0, items: [] }
        }
        const itemTotal = this.calculateTotal(item)
        groups[key].total += itemTotal
        groups[key].items.push({ ...item, _total: itemTotal })
        return groups
      }, {})

      const sortedGroups = Object.entries(grouped)
        .map(([target, group]) => ({
          target,
          total: group.total,
          items: group.items.sort((a, b) => b._total - a._total)
        }))
        .sort((a, b) => b.total - a.total)

      return sortedGroups.flatMap(group => 
        group.items.map(item => {
          const {  ...rest } = item
          return rest
        })
      )
    }
  },
  methods: {
    handleQuery() {
      this.loading = true
      dayloglist({
        start_time: this.timeRange[0],
        end_time: this.timeRange[1]
      }).then(res => {
        if(res.code == 1) {
          // 保存原始数据
          this.rawData = res.data
          if(this.rawData.length === 0) {
            this.$message.info("没有数据")
          }
        }
        this.loading = false
      }).catch(error => {
        this.$message.error('数据获取失败:'+error)
        this.loading = false
      })
    },
    calculateTotal(item) {
      return ['active', 'register', 'retainDay', 'wake', 'pay'].reduce((sum, field) => {
        return sum + (Number(item[field]) || 0)
      }, 0)
    },
    statusFormatter(row) {
      return row.status === 1 ? 
        <el-tag type="success" effect="dark">正常</el-tag> : 
        <el-tag type="danger" effect="dark">异常</el-tag>
    }
  }
}
</script>

<style lang="scss" scoped>
.dashboard-container {
  min-height: 100vh;
  padding: 10px 1%; // 左右留白5%
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  position: relative;
}


.main-content {
  width: 100%;
  position: relative;
  z-index: 1;
  max-width: 1600px; // 根据需求调整最大宽度
  margin: 0 auto;
}

.dashboard-header {
  text-align: center;
  margin-bottom: 40px;
  h1 {
    color: #2c3e50;
    font-size: 2.4rem;
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    i {
      color: #409EFF;
    }
  }
  .header-decoration {
    width: 60px;
    height: 4px;
    background: #409EFF;
    margin: 0 auto;
    border-radius: 2px;
  }
}

.operation-card {
  margin-bottom: 30px;
  border-radius: 12px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
  border: none;
  
  .filter-container {
    display: flex;
    gap: 20px;
    padding: 20px;
  }

  .filter-row {
    align-items: center; // 垂直居中

    // 统一所有列的高度
    > .el-col {
      display: flex;
      align-items: center;
      min-height: 60px; // 容器最小高度
    }
  }

}


.enhanced-time-picker {
  width: 100%;
  height: 38px;
  ::v-deep .el-input__inner {
    height: 38px;
    border-radius: 8px;
    padding-left: 40px;
    &:hover {
      border-color: #c0c4cc;
    }
  }
  ::v-deep .el-icon-date {
    left: 12px;
  }
  ::v-deep .el-range-editor {
    height: 38px;
    display: inline-flex;
    align-items: center;
    padding: 0 15px;
    
    .el-range-input {
      line-height: 38px;
    }
    
    .el-range-separator {
      line-height: 38px;
    }
  }
}

.search-input {
  ::v-deep .el-input__inner {
    height: 38px;
    border-radius: 8px;
    line-height: 38px;
    padding-left: 40px;
  }
  .el-icon-search {
    line-height: 48px !important;
    left: 12px;
    font-size: 16px;
    color: #909399;
  }
}

.query-button {
  width: 100%;
  height: 38px;
  padding: 0 40px;
  border-radius: 8px;
  font-size: 16px;
  letter-spacing: 1px;
  transition: all 0.3s ease;

  ::v-deep span {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
    
    i {
      margin-right: 8px;
    }
  }
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
  }
}

.data-card {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
  border: none;
}




.enhanced-table {
  ::v-deep .data-highlight {
    color: #70bd4a;
    font-weight: 500;
    position: relative;
    padding: 2px 6px;
    border-radius: 4px;
    background-color: rgba(103, 194, 58, 0.1);
    
    &::after {
      content: '';
      margin-left: 4px;
      font-size: 0.9em;
      color: #5daf34;
    }
  }

  ::v-deep .data-persent {
    color: #007ef5;
    font-weight: 500;
    position: relative;
    padding: 2px 6px;
    border-radius: 4px;
    background-color: rgba(247, 248, 247, 0.1);
    
    &::after {
      content: '';
      margin-left: 4px;
      font-size: 0.9em;
      color: #5daf34;
    }
  }

  // 移动端适配
  @media (max-width: 768px) {
    ::v-deep .data-highlight .data-persent {
      font-size: 12px;
      padding: 1px 4px;
    }
  }
}

.enhanced-table {
  ::v-deep .cell {
    white-space: nowrap;
    line-height: 1.5;
  }
}

@media (max-width: 768px) {
  .dashboard-container {
    padding: 20px;
  }
  
  .filter-container {
    flex-direction: column;
  }
  
  .query-button {
    width: 100%;
  }
}

// 响应式调整
@media (max-width: 768px) {
  .filter-row {
    > .el-col {
      min-height: auto !important;
    }
  }
  
  .enhanced-time-picker,
  .search-input {
    ::v-deep .el-input__inner {
      height: 44px;
      line-height: 44px;
    }
  }
  
  .query-button {
    height: 44px;
  }
}


.data-card {
  overflow-x: auto; // 添加横向滚动
  .el-table {
    min-width: 600px; // 保证表格最小宽度
  }
}

@media (max-width: 768px) {
  .filter-row {
    .time-col {
      margin-bottom: 15px;
    }
    
    .el-date-editor {
      margin-bottom: 10px;
    }
  }

  .enhanced-table {
    font-size: 12px;
    th, td {
      padding: 8px 5px;
    }
  }

  .operation-card {
    margin-bottom: 15px;
    ::v-deep .el-card__body {
      padding: 15px;
    }
  }

  .query-button {
    width: 100%;
    margin-top: 5px;
  }
}

@media (max-width: 480px) {
  .dashboard-container {
    padding: 10px;
  }
  
  .el-date-editor {
    width: 100%;
  }
  
  .search-input {
    margin-top: 10px;
  }
}

</style>